import { Component } from '@angular/core';

@Component({
  selector: 'parametrizer-observation-svg',
  templateUrl: './parametrizer-observation.component.html',
  styleUrls: ['./../../../svg.scss']
})
export class ParametrizerObservationSvgComponent  {}